<template>
  <VModal :showing="showing" container-classes="max-w-screen-md" @update:showing="$emit('update:showing', $event)">
    <div class="flex items-start mb-8">
      <span class="mr-4 rounded-full bg-red-100 w-10 h-10 grid place-items-center flex-shrink-0">
        <ExclamationTriangleIcon class="h-6 inline text-red-800" />
      </span>
      <div>
        <h2 class="text-xl mb-8 mr-8 truncate">{{ displayType }} scene does not exist</h2>
        <p class="text-gray-800 font-light">
          A {{ displayType }} scene for this slide was either never chosen or has been deleted. Please delete this slide and create a new
          {{ displayType }} slide.
        </p>
        <div class="flex flex-row gap-4 mt-8 w-full justify-end">
          <VButton class="w-42" data-testid="cancel-button" @click="$emit('update:showing', false)"> Cancel</VButton>
          <VButton class="w-42" variant="danger" data-testid="delete-button" @click="$emit('delete-slide', slide)"
            >Delete this slide</VButton
          >
        </div>
      </div>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed } from 'vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'

import type { Slide } from '@/entities/deck'

const props = defineProps({
  slide: {
    type: Object as PropType<Slide>,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['delete-slide', 'update:showing'])

const displayType = computed(() => {
  if (props.slide.type === 'M') return '3D'
  if (props.slide.type === 'S') return '360'
  return ''
})
</script>
